import { hasPermissionGuard } from "../../core/guards";
import { Constants } from "../../shared/constants/constants";
import { PermissionAction } from "../../shared/constants/enums";

export const viewGovernmentScoresPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.GOVERNMENT_SCORES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const createGovernmentScoresPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.create,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.GOVERNMENT_SCORES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageGovernmentScoresPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.GOVERNMENT_SCORES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageStrategyDashboardPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.STRATEGY_DASHBOARD_MANAGEMENT,
        },
      ],
    },
    redirectTo: "/403",
  }),
];
